import Decimal from 'decimal.js'

export const getBookingAmount = (amount, assignments = []) => {
  return assignments.reduce((bookingAmount, assignment) => {
    const { amount: assignmentAmount } = assignment
    return new Decimal(bookingAmount).minus(assignmentAmount).toDP(2).toNumber()
  }, amount)
}
